import { TagProps } from '@aircall/tractor-v2';
import { RoleName, ROLE_NAME } from '@constants/permissions.constants';

export function getRoleColor(roleName: RoleName): TagProps['variant'] | null {
  switch (roleName) {
    case ROLE_NAME.OWNER:
      return 'green';
    case ROLE_NAME.ADMIN:
      return 'purple';
    case ROLE_NAME.SUPERVISOR:
      return 'blue';
    case ROLE_NAME.AGENT:
      return 'yellow';
    default:
      return null;
  }
}
